import { authEndpoints } from "@shared/services/endpoints/auth.endpoints";
import { tradesEndpoints } from "@shared/services/endpoints/trades.endpoints";
import { commonEndpoints } from "@shared/services/endpoints/common.endpoints";
import { botsEndpoints } from "@shared/services/endpoints/bots.endpoints";
import { notificationsEndpoints } from "@shared/services/endpoints/notifications.endpoints";
import { configurationEndpoints } from "@shared/services/endpoints/configuration.endpoints";
import { dashboardEndpoints } from "@shared/services/endpoints/dashboard.endpoints";
import { portfolioEndpoints } from "@shared/services/endpoints/portfolio.endpoints";
import { signalsEndpoints } from "@shared/services/endpoints/signals.endpoints";
import { marketplaceEndpoints } from "@shared/services/endpoints/marketplace.endpoints";
import { settingsEndpoints } from "@shared/services/endpoints/settings.endpoints";
import { adminEndpoints } from "@shared/services/endpoints/admin.endpoints";

const allEndpoints = {
  common: commonEndpoints,
  authentication: authEndpoints,
  trades: tradesEndpoints,
  bots: botsEndpoints,
  notifications: notificationsEndpoints,
  configuration: configurationEndpoints,
  dashboard: dashboardEndpoints,
  portfolio: portfolioEndpoints,
  signals: signalsEndpoints,
  marketplace: marketplaceEndpoints,
  settings: settingsEndpoints,
  admin: adminEndpoints,
};

export default allEndpoints;
